module.exports = __webpack_public_path__ + "media/images/850/weight_loss_bed-1e4bb59dacccf4ff2997cd640ddc902d.jpg";